import { requestGQL } from 'common/graphQlClient';
import { gql } from 'graphql-request';

export const DELETE_REPEATER = gql`
  mutation deleteRepeater($input: DeleteNodeInput!) {
    deleteRepeater(input: $input)
  }
`;

export const deleteRepeater = (propertyId: number) => (nodeId: string) => {
  return requestGQL(DELETE_REPEATER, { input: { propertyId, nodeId } });
};
